$bog_blitz_profile_page $mol_page
	Head null
	body /
		<= Card $mol_view
			sub /
				<= Avatar_circle $mol_view
					sub /
						<= avatar_preview null
				<= Avatar $mol_button_open
					sub /
						<= Avatar_label $mol_paragraph
							title @ \Change photo
						<= Avatar_native $mol_button_open_native
							files? <=> avatar_files? /File
							accept \image/*
							multiple false
				<= Name_row $mol_view
					sub /
						<= Name_input $mol_string_button
							hint @ \Your name
							value? <=> profile_name? \
				<= Stats $mol_view
					sub <= stat_rows /
				<= Fun_card $mol_view
					sub /
						<= Fun_title $mol_paragraph
							title @ \Your Quiz Persona
						<= Fun_text $mol_paragraph
							title <= persona_text \
		<= Games_section $mol_view
			sub /
				<= Games_title $mol_paragraph
					title \История игр
				<= Games_search $mol_search
					query? <=> games_query? \
				<= Games_list $mol_list
					rows <= game_rows /
				<= Games_empty $mol_paragraph
					title <= games_empty_text \
	Avatar_image $mol_image
		uri <= avatar_uri \
	Avatar_icon $mol_avatar
		id <= player_id \
	Stat_row* $mol_view
		sub /
			<= Stat_label* $mol_paragraph
				title <= stat_label* \
			<= Stat_value* $mol_paragraph
				title <= stat_value* \
	Game_row* $mol_link
		arg <= game_arg* *
		sub /
			<= Game_info* $mol_view
				sub /
					<= Game_title* $mol_paragraph
						title <= game_title* \
					<= Game_details* $mol_paragraph
						title <= game_details* \
			<= Game_score* $mol_paragraph
				title <= game_score* \
